import validate, { checkRequiredField, checkIsInferior } from 'common/formValidation/lib';
import { validators as customisationValidators } from '../../common/simulationDetails/CustomisationForm';

const formValidate = validate([
    checkRequiredField('name'),
    ...customisationValidators,
    checkIsInferior(
        'durationBeforeRealEstateIndexation',
        'simulationDuration',
        'La durée avant réindexation doit être inférieure à la durée de la simulation',
    ),
]);

export default formValidate;
